<template>
  <div
    v-if="isLoading || isBaggageAvailable"
    class="bg-background-neutral-secondary space-y-4 rounded-2xl p-4"
  >
    <div
      v-if="isLoading"
      class="flex flex-col items-center justify-center space-y-4"
    >
      <div class="shimmer h-[66px] w-full rounded-2xl"></div>
      <div class="shimmer h-10 w-full rounded-2xl"></div>
    </div>
    <template v-else-if="isBaggageAvailable">
      <div class="flex items-center justify-between space-x-3">
        <img
          src="@/assets/images/baggage-icon.webp"
          width="48"
          height="48"
          alt=""
        />
        <div class="space-y-0.5">
          <h2 class="text-text-neutral-primary text-base font-semibold">
            {{ $t('ancillaries.baggages.title') }}
          </h2>
          <p class="text-text-neutral-secondary text-sm">
            {{
              descriptionText || $t('ancillaries.baggages.servicesDescription')
            }}
          </p>
        </div>
      </div>
      <FreeButton
        class="w-full"
        size="sm"
        type="button"
        :class="hasSelectedBaggage ? 'gray-button' : 'green-main-button'"
        @click="emit('onProceedToBaggages')"
      >
        {{
          hasSelectedBaggage
            ? $t('general.edit')
            : $t('ancillaries.baggages.add')
        }}
      </FreeButton>
    </template>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { FreeButton } from 'freedom-shared';
  import { prettyPrice } from '@aviata/text-fns';

  const props = defineProps<{
    isLoading: boolean;
    hasSelectedBaggage: boolean;
    totalPrice: number | null;
    isBaggageAvailable: boolean;
  }>();

  const emit = defineEmits<{
    onProceedToBaggages: [];
  }>();

  const { t } = useI18n();

  const descriptionText = computed(() => {
    if (Number(props.totalPrice) > 0) {
      return t('ancillaries.baggages.addedBaggage', {
        price: prettyPrice(String(props.totalPrice)),
      });
    }
    return t('ancillaries.baggages.servicesDescription');
  });
</script>
